import { BaseApiResponse } from '../shared/shared.type'
import { SingleOrigin } from '../origin/origin.type'

export type FulfilmentCentreLocation = {
  type: string
  coordinates: [number, number]
  _id: string
}

export const FulfilmentCentreRole = {
  PARENT: 'PARENT',
  CHILD: 'CHILD',
} as const

export type FulfilmentCentreRole =
  (typeof FulfilmentCentreRole)[keyof typeof FulfilmentCentreRole]

export type FulfilmentCentre = {
  _id: string
  name: string
  role?: FulfilmentCentreRole
  parentFulfilmentCentre?: string | null
  isActive?: boolean
  location?: FulfilmentCentreLocation
  address?: string
  image?: string | null
  createdAt: string
  domain?: string
  numberOfCreators?: number
  updatedAt: string
  origin?: SingleOrigin
  config?: {
    lifestyle?: boolean
    event?: boolean
    food?: boolean | string
  }
}

export type FulfilmentCentreBasic = Omit<FulfilmentCentre, 'numberOfCreators'>

export type FulfilmentCentreData = {
  docs: FulfilmentCentre[]
  total: number
  totalPages: number
  currentPage: number
  nextPage: number | null
  prevPage: number | null
  hasNextPage: boolean
  hasPrevPage: boolean
}

export type GetFulfilmentCentre = BaseApiResponse & {
  data: FulfilmentCentre & {
    creators: {
      name: string
      _id: string
    }[]
  }
}

export type FulfilmentCentreResponse = BaseApiResponse & {
  data: FulfilmentCentreData
}

export type CreateFulfilmentCenter = {
  name: string
  role?: FulfilmentCentreRole
  parentFulfilmentCentre?: string | null
  isActive?: boolean
  coordinates?: [number, number]
  address?: string
  domain?: string
  image?: string | null
  config?: {
    lifestyle?: boolean
    event?: boolean
    food?: boolean | string
  }
  origin?: {
    _id: string
    name: string
  }
}

export type CreateFulfilmentCenterResponse = BaseApiResponse & {
  data: FulfilmentCentre
}

export type RemoveFulfillmentCenterCreatorsPayload = {
  id: string
  vendorId: string
  remove?: boolean
}

export type AddFulfillmentCenterCreatorsPayload = {
  id: string
  vendors: string[]
}
